//////////////////////////////////////////////////////////////////////
// This is the main component fot the section of Payroll Info,
// this controlls the objects to show in the rows as well of the settings on all the component
// canEdit:  should be pass if this section is editable in general
// //////////////////////////////////////////////////////////////////////
import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import { PayrollInfoQuery } from '../queries/index'
import Spinner from '../../common/Spinner'
import BusinessUtil from '../../shared/utils/BusinessUtil'
import SectionTable from '../SectionTable'

class PayrollInfo extends Component {
  get questionNumbers() {
    return {
      '700': 'Average monthly payroll',
      '705': 'Supporting documentation(s)',
      '706': 'Explanation of average monthly payroll amount'
    }
  }
  getObjectRows = () => {
    const { props: { data: { loan: { businesses } } }, questionNumbers } = this
    const { oc: { answers } } = new BusinessUtil(businesses)
    const keys =  Object.keys(questionNumbers)
    const answersRequested = answers.filter(({ questionNumber }) => (
      keys.includes(String(questionNumber))
    ))

    let objectRows = []
    answersRequested.forEach(answer => {
      const hash = {
        object: answer,
        label: questionNumbers[String(answer.questionNumber)]
      }
      objectRows = objectRows.concat(hash)
    })

    return objectRows.sort((
      { object: { questionNumber: sortA } }, { object: { questionNumber: sortB } }) => (
        sortA - sortB
    ))
  }
  getHelpers = () => {
    const { props: { data: { loan: { businesses } } } } = this
    const { oc: { questions } } = new BusinessUtil(businesses)

    return {
      questions
    }
  }
  render() {
    const { data: { loan }, section, customerService } = this.props

    if (!loan) {
      return <Spinner />
    }

    return (
      <SectionTable
        objectRows={this.getObjectRows()}
        sectionTitle="Payroll Information"
        loan={loan}
        section={section}
        canEdit
        customerService={customerService}
        helpers={this.getHelpers()}
      />
    )
  }
}

export { PayrollInfo }

export default graphql(PayrollInfoQuery, {
  options: ({ loanId }) => ({
    variables: {
      loanId
    }
  })
})(PayrollInfo)
